import React, { useState } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { IconChevronRightSmall } from '@sololearnorg/sol';
import { useContainerData } from '../../../../../shared/public/SlHooks/useContainerData';
import { AIChatPlaygroundStore } from '../../../AIChatPlaygroundStore';
import { ClickType, aIChatPlaygroundContext } from '../../../aIChatPlaygroundConstants';
import { MenuBook } from '../../../../../shared/public/assets/icons/MenuBook';
import { SlExternalWindowPanel } from '../../../../../shared/public/SlExternalWindowPanel/SlExternalWindowPanel';
import s from './AIChatPlaygroundSettingInfo.scss';
import { Container, i18n } from '../../../../../symphony';
import { AIChatPlaygrountTrackingService } from '../../../services/AIChatPlaygrountTrackingService';

export const AIChatPlaygroundSettingInfo = () => {
	useStyles(s);
	const trackingService = Container.take(aIChatPlaygroundContext.value, AIChatPlaygrountTrackingService);
	const aiChatSettings = Container.take('global', 'ai-chat-settings');
	const [isPanelOpen, setIsPanelOpen] = useState(false);
	const [isWrapperOpened, setIsWrapperOpened] = useState(false);
	const { modelConfigs } = useContainerData(
		aIChatPlaygroundContext.value,
		AIChatPlaygroundStore,
		['modelConfigs'],
	);

	const openHandler = () => {
		trackingService.trackPlaygroundClick(ClickType.SettingsGuide);
		setIsPanelOpen(true);
		setIsWrapperOpened(true);
	};

	const closeHandler = () => {
		setIsPanelOpen(false);
		setTimeout(() => {
			setIsWrapperOpened(false);
		}, 500);
	};

	return (
		<div className="ai-chat-playground-settings-info">
			<MenuBook className="ai-chat-playground-settings-info__book-icon" onClick={openHandler} />
			{isWrapperOpened && (
				<div className="ai-chat-playground-settings-info__panel-wrapper">
					<SlExternalWindowPanel
						onClose={closeHandler}
						isPanelOpen={isPanelOpen}
						shouldAnimate
					>
						<div className="ai-chat-playground-settings-info__panel">
							<div
								className="ai-chat-playground-settings-info__hide-panel"
								onClick={closeHandler}
							>
								{i18n.t('web-kodie.hide-vertical-panel')}
								{' '}
								<IconChevronRightSmall />
							</div>
							<div className="ai-chat-playground-settings-info__panel-title">
								{i18n.t('ai-chat.settings-guide.title')}
							</div>
							<div className="ai-chat-playground-settings-info__panel-items">
								{modelConfigs.map((setting) => (
									<div key={setting.key} className="ai-chat-playground-settings-info__panel-item">
										<div key={setting.key} className="ai-chat-playground-settings-info__panel-item-title">
											{i18n.t(aiChatSettings[setting.key].title)}
										</div>
										<div key={setting.key} className="ai-chat-playground-settings-info__panel-item-description">
											{i18n.t(aiChatSettings[setting.key].description)}
										</div>
									</div>
								))}
							</div>
						</div>
					</SlExternalWindowPanel>
				</div>
			)}
		</div>
	);
};
